import React from 'react';
import { AllBlogsTab } from './AllBlogsTab';

export const BlogTab = ({ blogs, activeChildTab }) => (
  <>{activeChildTab === 0 ? <AllBlogsTab blogs={blogs} /> : null}</>
);
